import { faPlus } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PAGE_HASH } from "../../../../../../atoms/location/locationAtom";
import { TRACKING_EVENTS_NAME } from "../../../../../../constants/trackingEvents";
import { ButtonProps } from "../../../../../core-ui/components/Button/Button";
import { FixedMinWidthButton } from "../../../../../core-ui/components/Button/FixedMinWidthButton";

export const CreateReleaseButton = (props: ButtonProps) => {
  return (
    <FixedMinWidthButton
      startIcon={<FontAwesomeIcon icon={faPlus} />}
      href={PAGE_HASH.CREATE_RELEASE}
      analyticsEvent={{
        name: TRACKING_EVENTS_NAME.ARTIST_CLICKED_CREATE_RELEASE_BUTTON,
      }}
      {...props}
    >
      Create Release
    </FixedMinWidthButton>
  );
};
